function EmptyComponent() {
  return <div>No disputes to display</div>;
}

export default EmptyComponent;
